// @ts-nocheck
//https://github.com/meshakeeb/StoreJS/blob/master/store.js

// Capacidad REAL de localStorage, cacheada a nivel de módulo (fuera del
// objeto: como propiedad creaba un ciclo de inferencia que rompía el
// declaration emit de TS). El check antiguo (typeof Storage !== "undefined")
// solo miraba que el API exista — pero en Chrome/webviews con cookies-y-datos
// bloqueados el MERO ACCESO a window.localStorage lanza SecurityError
// ("Access is denied"), issue 1J: 125 usuarios cuyos leads/analytics morían
// con la excepción propagada porque ningún fallback llegaba a ejecutarse.
var localStorageUsable = null;

export const Vault = {
  set: function (key, value, options) {
    if (this.is_localstorage()) {
      return this.local(key, value, options);
    } else {
      return this.cookie(key, value, options);
    }
  },

  get: function (key) {
    if (this.is_localstorage()) {
      return this.local(key);
    } else {
      return this.cookie(key);
    }
  },

  remove: function (key) {
    if (!key) {
      return false;
    }

    try {
      localStorage.removeItem(key);
    } catch (e) {
      // storage denegado: la cookie de abajo es best-effort igualmente
    }
    this.cookie(key, "", { expires: -1 });

    return true;
  },

  // LocaStorge
  local: function (key, value, options) {
    if (!key) {
      return false;
    }

    // Ningún camino puede LANZAR hacia el caller: los consumidores (User,
    // Tracking, ClickIds) tratan `false` como "no hay dato" y caen a sus
    // copias en memoria — una excepción aquí se saltaba esa red entera.
    try {
      // Write
      if (arguments.length > 1) {
        value = {
          value: value,
          expires: this.expiry(options.expires),
        };

        localStorage.setItem(key, JSON.stringify(value));

        return true;
      }

      // Read
      var item = localStorage.getItem(key);

      if (!item) {
        return false;
      }

      item = JSON.parse(item);

      if (item.expires && Date.now() > item.expires) {
        localStorage.removeItem(key);
        return false;
      }

      return item.value;
    } catch (e) {
      return false;
    }
  },

  // Cookies
  cookie: function (key, value, options) {
    if (!key) {
      return false;
    }

    try {
      // OJO: cookieUnsafe es función LIBRE del módulo, no método del Vault.
      // La regresión `this._cookieUnsafe` (1/8-5/8/2026) dejó TODA la rama
      // cookie muerta: TypeError → catch → false, y los usuarios con
      // localStorage denegado pero cookies válidas no persistían nada
      // (visitor id nuevo por página, UTMs perdidas entre páginas).
      return cookieUnsafe.apply(this, arguments);
    } catch (e) {
      // document.cookie también puede estar denegado (sandbox/data-blocked)
      return false;
    }
  },

  is_localstorage: function () {
    if (localStorageUsable !== null) {
      return localStorageUsable;
    }
    try {
      var probeKey = "__vault_probe__";
      window.localStorage.setItem(probeKey, "1");
      window.localStorage.removeItem(probeKey);
      localStorageUsable = true;
    } catch (e) {
      // Acceso denegado o cuota 0: caer a la rama de cookies (que también va
      // envuelta — si ambas fallan, los callers reciben false y usan memoria)
      localStorageUsable = false;
    }
    return localStorageUsable;
  },

  expiry: function (val) {
    if (!val) {
      return false;
    }

    if (-1 === val) {
      var d = new Date();
      d.setYear(1970);
      return d.getTime();
    }

    var interval = parseInt(val),
      unit = val.replace(interval, "");

    if ("d" === unit) {
      interval = interval * 24 * 60 * 60 * 1000;
    }

    if ("h" === unit) {
      interval = interval * 60 * 60 * 1000;
    }

    if ("m" === unit) {
      interval = interval * 60 * 1000;
    }

    if ("s" === unit) {
      interval = interval * 1000;
    }

    return Date.now() + interval;
  },

  extend: function (target, ...sources) {
    sources.forEach((source) => {
      for (let key in source) {
        if (source.hasOwnProperty(key)) {
          target[key] = source[key];
        }
      }
    });

    return target;
  },
};

// Fuera del objeto Vault a propósito: como método interno auto-referenciado
// rompía el declaration emit de TypeScript (TS9005). Se invoca con
// cookieUnsafe.apply(this, arguments) desde Vault.cookie, que es quien
// captura las excepciones (document.cookie puede estar denegado).
function cookieUnsafe(key, value, options) {
  // Write
  if (arguments.length > 1) {
    options = this.extend(
      {},
      {
        path: "/",
        expires: "30d",
      },
      options,
    );

    options.expires = this.expiry(options.expires);
    var date = new Date();
    date.setTime(options.expires);

    if ("object" === typeof value) {
      value = JSON.stringify(value);
    }

    return (document.cookie = [
      encodeURIComponent(key) + "=" + encodeURIComponent(value),
      options.expires ? "; expires=" + date.toUTCString() : "", // Use expires attribute, max-age is not supported by IE
      options.path ? "; path=" + options.path : "",
      options.domain ? "; domain=" + options.domain : "",
      options.secure ? "; secure" : "",
    ].join(""));
  }

  // Read
  var cookies = document.cookie ? document.cookie.split("; ") : [],
    rdecode = /(%[0-9A-Z]{2})+/g,
    i = 0,
    result = false;

  for (; i < cookies.length; i++) {
    var parts = cookies[i].split("="),
      name = parts[0].replace(rdecode, decodeURIComponent),
      cookie = parts.slice(1).join("=");

    if (key === name) {
      if ('"' === cookie.charAt(0)) {
        cookie = cookie.slice(1, -1);
      }

      try {
        cookie = cookie.replace(rdecode, decodeURIComponent);
        try {
          cookie = JSON.parse(cookie);
        } catch (e) {}
      } catch (e) {}

      result = cookie;
      break;
    }
  }

  return result;
}
